export const SELECT_STERILISED = 'SELECT_STERILISED_SIGNALMENT';
export const SELECT_PREGNANT = 'SELECT_PREGNANT_SIGNALMENT';
export const SELECT_LACTATION = 'SELECT_LACTATION_SIGNALMENT';
export const DEFAULT = 'DEFAULT_SIGNALMENT';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_SIGNALMENT';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_SIGNALMENT';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_SIGNALMENT';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
